(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-io.js', './ktor-ktor-http.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-io.js'), require('./ktor-ktor-http.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-serialization'.");
    }
    if (typeof this['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-serialization'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-serialization'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-serialization'.");
    }
    root['ktor-ktor-serialization'] = factory(typeof this['ktor-ktor-serialization'] === 'undefined' ? {} : this['ktor-ktor-serialization'], this['kotlin-kotlin-stdlib'], this['ktor-ktor-io'], this['ktor-ktor-http'], this['kotlinx-coroutines-core']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var Exception = kotlin_kotlin.$_$.ge;
  var VOID = kotlin_kotlin.$_$.g;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.k1;
  var captureStack = kotlin_kotlin.$_$.r9;
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.g;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
  var parseAndSortHeader = kotlin_io_ktor_ktor_http.$_$.i1;
  var Companion_instance = kotlin_io_ktor_ktor_io.$_$.f;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var CoroutineImpl = kotlin_kotlin.$_$.j9;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.v8;
  var initMetadataForLambda = kotlin_kotlin.$_$.la;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ja;
  var asFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q;
  var firstOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ContentConvertException, 'ContentConvertException', VOID, Exception);
  initMetadataForClass(JsonConvertException, 'JsonConvertException', VOID, ContentConvertException);
  function register$default(contentType, converter, configuration, $super) {
    var tmp;
    if (configuration === VOID) {
      tmp = Configuration$register$lambda;
    } else {
      tmp = configuration;
    }
    configuration = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.j3p(contentType, converter, configuration);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.j3p.call(this, contentType, converter, configuration);
    }
    return tmp_0;
  }
  initMetadataForInterface(Configuration, 'Configuration');
  function serialize(contentType, charset, typeInfo, value, $completion) {
    return this.m3p(contentType, charset, typeInfo, value, $completion);
  }
  function serializeNullable(contentType, charset, typeInfo, value, $completion) {
    return this.l3p(contentType, charset, typeInfo, ensureNotNull(value), $completion);
  }
  initMetadataForInterface(ContentConverter, 'ContentConverter', VOID, VOID, VOID, [4, 3]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector], [1]);
  initMetadataForLambda(deserialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(deserialize$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($deserializeCOROUTINE$0, CoroutineImpl);
  //endregion
  function ContentConvertException(message, cause) {
    cause = cause === VOID ? null : cause;
    Exception_init_$Init$(message, cause, this);
    captureStack(this, ContentConvertException);
  }
  function JsonConvertException(message, cause) {
    cause = cause === VOID ? null : cause;
    ContentConvertException.call(this, message, cause);
    captureStack(this, JsonConvertException);
  }
  function Configuration$register$lambda($this$null) {
    return Unit_instance;
  }
  function Configuration() {
  }
  function ContentConverter() {
  }
  function deserialize(_this__u8e3s4, body, typeInfo, charset, $completion) {
    var tmp = new $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function suitableCharset(_this__u8e3s4, defaultCharset) {
    defaultCharset = defaultCharset === VOID ? Charsets_getInstance().w30_1 : defaultCharset;
    var tmp0_elvis_lhs = suitableCharsetOrNull(_this__u8e3s4, defaultCharset);
    return tmp0_elvis_lhs == null ? defaultCharset : tmp0_elvis_lhs;
  }
  function suitableCharsetOrNull(_this__u8e3s4, defaultCharset) {
    defaultCharset = defaultCharset === VOID ? Charsets_getInstance().w30_1 : defaultCharset;
    var tmp0_iterator = parseAndSortHeader(_this__u8e3s4.w2i(HttpHeaders_getInstance().n3e_1)).g();
    while (tmp0_iterator.h()) {
      var charset = tmp0_iterator.i().vd();
      if (charset === '*')
        return defaultCharset;
      else if (Companion_instance.y33(charset))
        return Companion_instance.x33(charset);
    }
    return null;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.a3q_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).m13 = function (value, $completion) {
    return this.a3q_1(value, $completion);
  };
  function deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
    this.j3q_1 = $$this$unsafeFlow;
    this.k3q_1 = $charset;
    this.l3q_1 = $typeInfo;
    this.m3q_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deserialize$o$collect$slambda).s3q = function (value, $completion) {
    var tmp = this.t3q(value, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(deserialize$o$collect$slambda).m9 = function (p1, $completion) {
    return this.s3q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deserialize$o$collect$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            var tmp_0 = this;
            tmp_0.o3q_1 = this.j3q_1;
            var tmp_1 = this;
            tmp_1.p3q_1 = this.n3q_1;
            var tmp_2 = this;
            tmp_2.q3q_1 = this.p3q_1;
            this.j8_1 = 1;
            suspendResult = this.q3q_1.n3p(this.k3q_1, this.l3q_1, this.m3q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.r3q_1 = suspendResult;
            this.j8_1 = 2;
            suspendResult = this.o3q_1.m13(this.r3q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(deserialize$o$collect$slambda).t3q = function (value, completion) {
    var i = new deserialize$o$collect$slambda(this.j3q_1, this.k3q_1, this.l3q_1, this.m3q_1, completion);
    i.n3q_1 = value;
    return i;
  };
  function deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
    var i = new deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation);
    var l = function (value, $completion) {
      return i.s3q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$1(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c3r_1 = _this__u8e3s4;
    this.d3r_1 = collector;
  }
  protoOf($collectCOROUTINE$1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            var tmp_0 = this;
            tmp_0.e3r_1 = this.d3r_1;
            this.j8_1 = 1;
            var tmp_1 = deserialize$o$collect$slambda_0(this.e3r_1, this.c3r_1.g3r_1, this.c3r_1.h3r_1, this.c3r_1.i3r_1, null);
            suspendResult = this.c3r_1.f3r_1.o13(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function _no_name_provided__qut3iv($this, $charset, $typeInfo, $body) {
    this.f3r_1 = $this;
    this.g3r_1 = $charset;
    this.h3r_1 = $typeInfo;
    this.i3r_1 = $body;
  }
  protoOf(_no_name_provided__qut3iv).n13 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$1(this, collector, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(_no_name_provided__qut3iv).o13 = function (collector, $completion) {
    return this.n13(collector, $completion);
  };
  function deserialize$slambda($body, resultContinuation) {
    this.r3r_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deserialize$slambda).t3r = function (it, $completion) {
    var tmp = this.t3q(it, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(deserialize$slambda).m9 = function (p1, $completion) {
    return this.t3r((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deserialize$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        if (tmp === 0) {
          this.k8_1 = 1;
          return !(this.s3r_1 == null) || this.r3r_1.o2q();
        } else if (tmp === 1) {
          throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(deserialize$slambda).t3q = function (it, completion) {
    var i = new deserialize$slambda(this.r3r_1, completion);
    i.s3r_1 = it;
    return i;
  };
  function deserialize$slambda_0($body, resultContinuation) {
    var i = new deserialize$slambda($body, resultContinuation);
    var l = function (it, $completion) {
      return i.t3r(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w3p_1 = _this__u8e3s4;
    this.x3p_1 = body;
    this.y3p_1 = typeInfo;
    this.z3p_1 = charset;
  }
  protoOf($deserializeCOROUTINE$0).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            var this_0 = asFlow(this.w3p_1);
            var tmp_0 = new _no_name_provided__qut3iv(this_0, this.z3p_1, this.y3p_1, this.x3p_1);
            suspendResult = firstOrNull(tmp_0, deserialize$slambda_0(this.x3p_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            var tmp_1;
            if (!(result == null)) {
              tmp_1 = result;
            } else {
              if (!this.x3p_1.o2q()) {
                tmp_1 = this.x3p_1;
              } else {
                var tmp0_safe_receiver = this.y3p_1.j3c_1;
                if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fa()) === true) {
                  tmp_1 = NullBody_instance;
                } else {
                  throw new ContentConvertException('No suitable converter found for ' + this.y3p_1.toString());
                }
              }
            }

            return tmp_1;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = deserialize;
  _.$_$.b = register$default;
  _.$_$.c = Configuration;
  _.$_$.d = ContentConverter;
  _.$_$.e = JsonConvertException;
  _.$_$.f = suitableCharset;
  //endregion
  return _;
}));
